import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onInviteUser, hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">No users found</h3>
        <p className="text-muted-foreground text-center mb-6 max-w-md">
          No users match your current filters. Try adjusting your search criteria.
        </p>
        <Button
          variant="outline"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <Icon name="Users" size={32} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">No users yet</h3>
      <p className="text-muted-foreground text-center mb-6 max-w-md">
        Get started by inviting your first user to the platform.
      </p>
      <Button
        variant="default"
        iconName="UserPlus"
        iconPosition="left"
        onClick={onInviteUser}
      >
        Invite User
      </Button>
    </div>
  );
};

export default EmptyState;